import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Slider from "react-slick";
import styled from "styled-components";
import { Image } from "hesus-ui-kit";
import transportOnlyIcon from "@icons/ic-transport-only.svg";
import transportTreatmentIcon from "@icons/ic-transport-treatment.svg";
import treatmentIcon from "@icons/ic-treatment.svg";
import unknownIcon from "@icons/ic-unknown.svg";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import {
  ButtonData,
  TransportDetail,
  BlockRow,
  SliderGridRow,
  ProductLabel,
} from "../../CenterProductsList.styled";
import "../../CenterProductsList.scss";

const CenterProductPrices = (props) => {
  const { t, prices, status } = props;

  return (
    <BlockRow opacity={!status ? ".2" : 1}>
      {!!status && (prices !== "" || prices !== null) && (
        <Slider className="mainSlider" style={{ width: "100%" }}>
          {!prices
            ? null
            : prices.map((price, index) => {
                return (
                  <div key={index}>
                    <SliderGridRow column="50px auto">
                      {price.priceType === 1 && (
                        <Image
                          src={treatmentIcon}
                          alt={t("CENTRE_PRODUCT_PRICE_TREATMENT")}
                          title={t("CENTRE_PRODUCT_PRICE_TREATMENT")}
                          classname="center-products-list__transport-image-icon"
                        />
                      )}
                      {price.priceType === 2 && (
                        <Image
                          src={transportTreatmentIcon}
                          alt={t("CENTRE_PRODUCT_PRICE_TRANSPORT_TREATMENT")}
                          title={t("CENTRE_PRODUCT_PRICE_TRANSPORT_TREATMENT")}
                          classname="center-products-list__transport-image-icon"
                        />
                      )}
                      {price.priceType === 3 && (
                        <Image
                          src={unknownIcon}
                          alt={t("CENTRE_PRODUCT_PRICE_UNKNOWN")}
                          title={t("CENTRE_PRODUCT_PRICE_UNKNOWN")}
                          classname="center-products-list__transport-image-icon"
                        />
                      )}
                      {price.priceType === 4 && (
                        <Image
                          src={transportOnlyIcon}
                          alt={t("CENTRE_PRODUCT_PRICE_TRANSPORT")}
                          title={t("CENTRE_PRODUCT_PRICE_TRANSPORT")}
                          classname="center-products-list__transport-image-icon"
                        />
                      )}
                      <div>
                        {(price.label !== "" || price.label !== null) && (
                          <ProductLabel>{price.label}</ProductLabel>
                        )}
                        {!!price.isMemoryPrice && (
                          <ButtonData colour="#FF981E">{`${t(
                            "CENTRE_PRODUCT_PRICE_MEMORY"
                          )}`}</ButtonData>
                        )}
                        {price.price +
                          " " +
                          price.currency?.name +
                          "/" +
                          t(price.unit)}
                        <TransportDetail>
                          {!price.transportTypes
                            ? ""
                            : price?.transportTypes.length > 2
                            ? t(price?.transportTypes[0]?.name) +
                              "," +
                              t(price?.transportTypes[1]?.name) +
                              "(" +
                              price?.transportTypes.length +
                              ")"
                            : t(price?.transportTypes[0]?.name)}
                        </TransportDetail>
                      </div>
                    </SliderGridRow>
                  </div>
                );
              })}
        </Slider>
      )}
      {!status && (
        <TransportDetail>{t("CENTRE_PRODUCT_PRICES_INACTIVE")}</TransportDetail>
      )}
      {!!status && (prices === "" || prices === null) && (
        <TransportDetail>{t("CENTRE_PRODUCT_NO_PRICE")}</TransportDetail>
      )}
    </BlockRow>
  );
};

CenterProductPrices.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CenterProductPrices);
